import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data"],
  _excluded2 = ["data"],
  _excluded3 = ["data"],
  _excluded4 = ["data"],
  _excluded5 = ["data"],
  _excluded6 = ["data"],
  _excluded7 = ["data"],
  _excluded8 = ["data"],
  _excluded9 = ["data"],
  _excluded10 = ["data"],
  _excluded11 = ["data"],
  _excluded12 = ["data"],
  _excluded13 = ["data"],
  _excluded14 = ["data"],
  _excluded15 = ["data"],
  _excluded16 = ["data"],
  _excluded17 = ["data"],
  _excluded18 = ["data"];
/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.personalization.rpc.PersonalizationRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import { useQuery, useLazyQuery, useSuspenseQuery } from 'data-fetching-client';
import * as Queries from './PersonalizationRpc.dfc.new';
export function useSearchQuery(options) {
  const _useQuery = useQuery(Queries.SEARCH_QUERY, options),
    {
      data
    } = _useQuery,
    rest = _objectWithoutPropertiesLoose(_useQuery, _excluded);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    search: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useSearchLazyQuery(options) {
  const [getter, _ref] = useLazyQuery(Queries.SEARCH_QUERY, options);
  const {
      data
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded2);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    search: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useSearchSuspenseQuery(options) {
  const _useSuspenseQuery = useSuspenseQuery(Queries.SEARCH_QUERY, options),
    {
      data
    } = _useSuspenseQuery,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery, _excluded3);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    search: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useAutocompleteQuery(options) {
  const _useQuery2 = useQuery(Queries.AUTOCOMPLETE_QUERY, options),
    {
      data
    } = _useQuery2,
    rest = _objectWithoutPropertiesLoose(_useQuery2, _excluded4);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    autocomplete: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useAutocompleteLazyQuery(options) {
  const [getter, _ref2] = useLazyQuery(Queries.AUTOCOMPLETE_QUERY, options);
  const {
      data
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded5);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    autocomplete: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useAutocompleteSuspenseQuery(options) {
  const _useSuspenseQuery2 = useSuspenseQuery(Queries.AUTOCOMPLETE_QUERY, options),
    {
      data
    } = _useSuspenseQuery2,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery2, _excluded6);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    autocomplete: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetSuggestionSectionsQuery(options) {
  const _useQuery3 = useQuery(Queries.GET_SUGGESTION_SECTIONS_QUERY, options),
    {
      data
    } = _useQuery3,
    rest = _objectWithoutPropertiesLoose(_useQuery3, _excluded7);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getSuggestionSections: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetSuggestionSectionsLazyQuery(options) {
  const [getter, _ref3] = useLazyQuery(Queries.GET_SUGGESTION_SECTIONS_QUERY, options);
  const {
      data
    } = _ref3,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded8);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getSuggestionSections: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetSuggestionSectionsSuspenseQuery(options) {
  const _useSuspenseQuery3 = useSuspenseQuery(Queries.GET_SUGGESTION_SECTIONS_QUERY, options),
    {
      data
    } = _useSuspenseQuery3,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery3, _excluded9);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getSuggestionSections: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetSuggestionSectionsByTypeQuery(options) {
  const _useQuery4 = useQuery(Queries.GET_SUGGESTION_SECTIONS_BY_TYPE_QUERY, options),
    {
      data
    } = _useQuery4,
    rest = _objectWithoutPropertiesLoose(_useQuery4, _excluded10);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getSuggestionSectionsByType: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetSuggestionSectionsByTypeLazyQuery(options) {
  const [getter, _ref4] = useLazyQuery(Queries.GET_SUGGESTION_SECTIONS_BY_TYPE_QUERY, options);
  const {
      data
    } = _ref4,
    rest = _objectWithoutPropertiesLoose(_ref4, _excluded11);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getSuggestionSectionsByType: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetSuggestionSectionsByTypeSuspenseQuery(options) {
  const _useSuspenseQuery4 = useSuspenseQuery(Queries.GET_SUGGESTION_SECTIONS_BY_TYPE_QUERY, options),
    {
      data
    } = _useSuspenseQuery4,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery4, _excluded12);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getSuggestionSectionsByType: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useSearchAssetsQuery(options) {
  const _useQuery5 = useQuery(Queries.SEARCH_ASSETS_QUERY, options),
    {
      data
    } = _useQuery5,
    rest = _objectWithoutPropertiesLoose(_useQuery5, _excluded13);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    searchAssets: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useSearchAssetsLazyQuery(options) {
  const [getter, _ref5] = useLazyQuery(Queries.SEARCH_ASSETS_QUERY, options);
  const {
      data
    } = _ref5,
    rest = _objectWithoutPropertiesLoose(_ref5, _excluded14);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    searchAssets: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useSearchAssetsSuspenseQuery(options) {
  const _useSuspenseQuery5 = useSuspenseQuery(Queries.SEARCH_ASSETS_QUERY, options),
    {
      data
    } = _useSuspenseQuery5,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery5, _excluded15);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    searchAssets: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetRelevanceQuery(options) {
  const _useQuery6 = useQuery(Queries.GET_RELEVANCE_QUERY, options),
    {
      data
    } = _useQuery6,
    rest = _objectWithoutPropertiesLoose(_useQuery6, _excluded16);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getRelevance: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetRelevanceLazyQuery(options) {
  const [getter, _ref6] = useLazyQuery(Queries.GET_RELEVANCE_QUERY, options);
  const {
      data
    } = _ref6,
    rest = _objectWithoutPropertiesLoose(_ref6, _excluded17);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getRelevance: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetRelevanceSuspenseQuery(options) {
  const _useSuspenseQuery6 = useSuspenseQuery(Queries.GET_RELEVANCE_QUERY, options),
    {
      data
    } = _useSuspenseQuery6,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery6, _excluded18);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getRelevance: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}